import React, { useEffect, useState, useRef } from "react";
import { AutoComplete, DatePicker, MasterTable } from "../../components/_index";
import {
  Box,
  Button,
  Typography,
  Divider,
  Checkbox,
  Stack,
  Tooltip,
  Avatar,
  List,
  ListItem,
  ListItemText,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import { getQuestion } from "../../services/question.service";
import { postForm, updateForm } from "../../services/form.service";
import ListIcon from "@mui/icons-material/List";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import RemoveIcon from "@mui/icons-material/Remove";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import Styles from "../../assets/styles/Chat.module.scss";
import { getUser } from "../../services/user.service";
import { createGroup } from "../../services/group.service";

const AddChannel = () => {
  const location = useLocation();
  const selectedData = location.state?.selectedData;
  const formType = location.state?.formType;
  // console.log(selectedData, "SD");
  const [data, setData] = useState([]);
  const [channelUser, setChannelUser] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [groupName, setGroupName] = useState("");
  // console.log(formType, "FT");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const [questionData, setQuestionData] = useState([]);
  const [selectedQuestionData, setSelectedData] = useState({
    question: selectedData?.questionInfo.map((question) => question._id) || [],
  });

  const initialValues = {
    formName: selectedData?.formName || "",
  };

  const validationSchema = yup.object().shape({
    formName: yup.string().required("Form Name Required *"),
  });

  const handleCreateGroup = async () => {
    try {
      const res = await createGroup({ groupName, teamMembers: selectedUsers });
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.data.message, type: "error" }));
    }
  };

  // const data = [
  //   {
  //     id: 1,
  //     name: "Abinesh",
  //     email: "example@gmail.com",
  //     avatar: "H",
  //     backgroundColor: "#26A69A",
  //   },
  //   {
  //     id: 2,
  //     name: "John Doe",
  //     email: "john.doe@gmail.com",
  //     avatar: "J",
  //     backgroundColor: "#FF6347",
  //   },
  //   {
  //     id: 3,
  //     name: "Jane Smith",
  //     email: "jane.smith@gmail.com",
  //     avatar: "J",
  //     backgroundColor: "#4682B4",
  //   },
  //   {
  //     id: 4,
  //     name: "Michael Brown",
  //     email: "michael.brown@gmail.com",
  //     avatar: "M",
  //     backgroundColor: "#FFD700",
  //   },
  //   {
  //     id: 5,
  //     name: "Sara Johnson",
  //     email: "sara.johnson@gmail.com",
  //     avatar: "S",
  //     backgroundColor: "#8A2BE2",
  //   },
  //   {
  //     id: 6,
  //     name: "Chris Lee",
  //     email: "chris.lee@gmail.com",
  //     avatar: "C",
  //     backgroundColor: "#A52A2A",
  //   },
  //   {
  //     id: 7,
  //     name: "Laura Wilson",
  //     email: "laura.wilson@gmail.com",
  //     avatar: "L",
  //     backgroundColor: "#5F9EA0",
  //   },
  //   {
  //     id: 8,
  //     name: "David Harris",
  //     email: "david.harris@gmail.com",
  //     avatar: "D",
  //     backgroundColor: "#FF1493",
  //   },
  //   {
  //     id: 9,
  //     name: "Emma White",
  //     email: "emma.white@gmail.com",
  //     avatar: "E",
  //     backgroundColor: "#32CD32",
  //   },
  //   {
  //     id: 10,
  //     name: "William Clark",
  //     email: "william.clark@gmail.com",
  //     avatar: "W",
  //     backgroundColor: "#FF4500",
  //   },
  //   {
  //     id: 11,
  //     name: "Sophia Green",
  //     email: "sophia.green@gmail.com",
  //     avatar: "S",
  //     backgroundColor: "#7B68EE",
  //   },
  //   {
  //     id: 12,
  //     name: "James Hall",
  //     email: "james.hall@gmail.com",
  //     avatar: "J",
  //     backgroundColor: "#20B2AA",
  //   },
  // ];

  const [checked, setChecked] = useState(false);

  // Handle checkbox change in the header
  const handleHeaderCheckboxChange = (event) => {};

  // Handle checkbox change in the body
  const handleRowCheckboxChange = (event, index, row) => {
    //  console.log(event.target.checked,index,row)
    if (event.target.checked) {
      setSelectedUsers((prev) => [...prev, row?._id]);
      setData(data.filter((ele) => ele?._id !== row?._id));
      setChannelUser((prev) => [...prev, row]);
    }
  };

  const handleRemoveData = (row) => {
    console.log(row);
    setChannelUser(channelUser.filter((ele) => ele?._id !== row?._id));
    setSelectedUsers(selectedUsers.filter((id) => id !== row?._id));
    setData((prev) => [...prev, row]);
  };

  const getAllUsers = async () => {
    const resp = await getUser();
    setData(resp.data.data);
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  return (
    <div
      className={Styles.ChannelContainer}
      style={{ border: "1px solid #D5D7E8", height: "100%" }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 14px",
          alignItems: "center",
        }}
      >
        <Typography className={Styles.formHeader}>
          Create New Channel
        </Typography>
        <Box sx={{ display: "flex", gap: "10px" }}>
          <Button
            className="cancelButton"
            startIcon={<CloseIcon />}
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button
            className="addButton"
            startIcon={<SaveIcon />}
            onClick={handleCreateGroup}
          >
            {formType === "edit" ? "Update" : "Create"}
          </Button>
        </Box>
      </Box>
      <Divider />
      <Box>
        <Grid container>
          <Grid size={{ xs: 12, sm: 8 }}>
            <Box
              sx={{
                borderBottom: "1px solid #D5D7E8",
                width: "98.5%",
                padding: "20px 14px",
              }}
            >
              <Grid size={{ xs: 12, sm: 8 }}>
                <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                  Channel Name
                </Typography>
                <input
                  placeholder="Enter Channel Name"
                  className="InputField"
                  onChange={(e) => setGroupName(e.target.value)}
                />
              </Grid>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid #D5D7E8",
                width: "98.5%",
                padding: "20px 14px",
              }}
            >
              <Typography className="inputTitle" sx={{ fontSize: "12px" }}>
                Member
              </Typography>
              <Grid
                // size={{ xs: 12, sm: 12 }}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignContent: "center",
                  paddingRight: "20px",
                }}
              >
                <Grid sx={{ width: "76%" }}>
                  <Box
                    className="SearchInputBoxContainer"
                    sx={{ background: "white" }}
                  >
                    <SearchOutlinedIcon className="Search_Icon" />
                    <input
                      className="SearchInputBox"
                      style={{ background: "white", borderRadius: "10px" }}
                      placeholder="Search here"
                      // onChange={(e) => handleSearch(e.target.value)}
                    />
                  </Box>
                </Grid>
                <Button className={Styles.filterButton}>
                  <TuneIcon />
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      padding: "0 5px",
                      textTransform: "capitalize",
                    }}
                  >
                    Filter
                  </Typography>
                </Button>
              </Grid>
            </Box>
            {/* <Box
              sx={{
                height: "35.3%",
                overflow: "auto",
                scrollbarWidth: "none",
              }}
            > */}
            <TableContainer
              sx={{
                maxHeight: "28.5%", // Set a height that suits your layout
                overflowY: "auto", // Ensure the table body scrolls if the content overflows
                scrollbarWidth: "none",
              }}
            >
              <Table stickyHeader size="medium">
                <TableHead sx={{ padding: "10px" }}>
                  <TableRow
                    className={Styles.TableHeadRow}
                    sx={{ padding: "10px", borderBottom: "none" }}
                  >
                    <TableCell
                      padding="checkbox"
                      sx={{
                        background: "#FBFBFB",
                        borderBottom: "none",
                      }}
                    >
                      {" "}
                      <Checkbox
                        sx={{
                          color: "#00675D",
                          "&.Mui-checked": {
                            color: "#00675D",
                          },
                        }}
                        checked={checked}
                        onChange={handleHeaderCheckboxChange}
                      />
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        background: "#FBFBFB",
                        borderBottom: "none",
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ background: "#FBFBFB", borderBottom: "none" }}
                    >
                      Department
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{ background: "#FBFBFB", borderBottom: "none" }}
                    >
                      Role
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.map((data, index) => {
                    const isSelected = selectedUsers.includes(data?._id);
                    return (
                      <TableRow
                        hover
                        sx={{ backgroundColor: "white" }}
                        key={index}
                      >
                        <TableCell
                          padding="checkbox"
                          className={Styles.TableBodyCell}
                        >
                          <Checkbox
                            sx={{
                              color: "#00675D",
                              "&.Mui-checked": {
                                color: "#00675D",
                              },
                            }}
                            checked={isSelected}
                            onChange={(e) =>
                              handleRowCheckboxChange(e, index, data)
                            }
                          />
                        </TableCell>
                        <TableCell className={Styles.TableBodyCell}>
                          {data.name}
                          <br />
                          {data.email}
                        </TableCell>
                        <TableCell className={Styles.TableBodyCell}>
                          {data.roleData?.shortName}
                        </TableCell>
                        <TableCell className={Styles.TableBodyCell}>
                          {data.roleData?.roleName}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {/* </Box> */}
          </Grid>
          {/* <Grid size={{ xs: 12, sm: 1 }}>
            <Divider
              orientation="vertical"
              sx={{
                borderRight: "2px solid #D5D7E8",
                height: "100%",
                marginY: 2,
              }}
            />
          </Grid> */}
          <Grid
            size={{ xs: 12, sm: 4 }}
            sx={{ borderLeft: "1px solid #D5D7E8", height: "77vh" }}
          >
            <Stack
              sx={{
                padding: "10px 14px",
              }}
            >
              <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                Channel Members
              </Typography>
              <Stack direction={"row"} sx={{ justifyContent: "space-between" }}>
                <Typography
                  sx={{ fontSize: "12px", fontWeight: 600, color: "#7C7C7C" }}
                >
                  Members Selected (17/20000)
                </Typography>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#DB3A3A",
                    cursor: "pointer",
                  }}
                >
                  Remove All
                </Typography>
              </Stack>
            </Stack>
            <Stack
              sx={{
                background: "#FBFBFB",
                overflow: "scroll",
                scrollbarWidth: "none",
                padding: "5px 15px",
                height: "65vh",
              }}
            >
              <List
                sx={{
                  p: 0,
                  maxHeight: "20%",
                }}
                className="no-scrollbar"
              >
                {channelUser.map((item) => (
                  <ListItem
                    key={item._id}
                    sx={{
                      padding: 0,
                      py: 0.5,
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 32, // Set the width of the avatar
                        height: 32, // Set the height of the avatar (should match width for a circle)
                        borderRadius: "50%", // Ensure the avatar is circular
                        overflow: "hidden",
                        mr: 1.5,
                        fontSize: "16px",
                        fontWeight: 600,
                        background: "#26A69A",
                      }}
                    >
                      {item.avatar}
                    </Avatar>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      justifyContent={"space-between"}
                      sx={{ width: "100%" }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            fontSize: "14px",
                            color: "#000",
                          }}
                        >
                          {item.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "12px",
                            color: "#6F6F6F",
                          }}
                        >
                          {item.email}
                        </Typography>
                      </Box>
                      <Box>
                        <Grid
                          sx={{
                            background: "pink",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "20px",
                            height: "20px",
                          }}
                        >
                          <RemoveIcon
                            sx={{
                              color: "red",
                              width: "80%",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveData(item)}
                          />
                        </Grid>
                      </Box>
                    </Stack>
                  </ListItem>
                ))}
              </List>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default AddChannel;
